"use client";

// Better Auth does not require a global session provider.
// This component is kept as a pass-through wrapper for layout compatibility.
export function SessionProvider({ children }: { children: React.ReactNode }) {
    return <>{children}</>;
}
